module.exports = __webpack_public_path__ + "img/img4.ae2ae51c.png";